var _rect, _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerifyIdentity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 10,
    fill: "#DFF5FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.781 15.5a1 1 0 011-1h1.644a4.334 4.334 0 014.325 4.325v1.953a1 1 0 11-2 0v-1.953a2.335 2.335 0 00-2.325-2.325h-1.644a1 1 0 01-1-1zm-5.402 0a1 1 0 01-1 1l-1.68.001a2.32 2.32 0 00-2.318 2.32v1.957a1 1 0 11-2 0V18.82a4.32 4.32 0 014.316-4.32l1.681-.001a1 1 0 011 1zm11.371 8.514a1 1 0 011 1v4.531a4.335 4.335 0 01-4.325 4.325h-1.644a1 1 0 010-2h1.644a2.335 2.335 0 002.325-2.325v-4.53a1 1 0 011-1zm-17.368 0a1 1 0 011 1v4.535a2.32 2.32 0 002.317 2.32l1.68.002a1 1 0 11-.001 2l-1.68-.002a4.32 4.32 0 01-4.316-4.32v-4.535a1 1 0 011-1z",
    fill: "#00B4F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 25.014a1 1 0 011-1h21.132a1 1 0 110 2H13.5a1 1 0 01-1-1z",
    fill: "#00B4F5"
  })));
}
export default SvgVerifyIdentity;